import { render, staticRenderFns } from "./AiNoticeNotifier.vue?vue&type=template&id=5ae42aa0&"
import script from "./AiNoticeNotifier.vue?vue&type=script&lang=js&"
export * from "./AiNoticeNotifier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports